import * as React from "react";
import { Dropdown, Option, Field } from "@fluentui/react-components";
import { GlpiEntity } from "../types/glpi";

interface Props {
  entities: GlpiEntity[];
  loading: boolean;
  value: number | null;
  onChange: (id: number | null) => void;
  required?: boolean;
  error?: string;
}

export function EntityDropdown({
  entities,
  loading,
  value,
  onChange,
  required,
  error,
}: Props): React.ReactElement {
  const valueText = React.useMemo(() => {
    const e = entities.find((x) => x.id === value);
    return e ? e.completename || e.name : "";
  }, [entities, value]);

  return (
    <Field
      label="Entité"
      required={required}
      validationState={error ? "error" : "none"}
      validationMessage={error}
    >
      <Dropdown
        placeholder={loading ? "Chargement…" : "Sélectionner une entité"}
        value={valueText}
        selectedOptions={value !== null ? [String(value)] : []}
        onOptionSelect={(_, data) => {
          const v = data.optionValue ? Number(data.optionValue) : null;
          onChange(v);
        }}
        disabled={loading}
      >
        {loading && (
          <Option value="" text="Chargement..." disabled>
            Chargement&hellip;
          </Option>
        )}
        {entities.map((e) => (
          <Option key={e.id} value={String(e.id)} text={e.completename || e.name}>
            {e.completename || e.name}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
}
